/**
 * Maps the GraphQL merchant store shape onto what the tables and forms speak.
 */

import type { MerchantStoreGraphQL, MerchantStoreState } from './useMerchantStoresRelay';

export interface IMerchantStore {
  /** Ash id — the row key and the segment in every merchant-store route. */
  id: string;
  /** Legacy integer id, still how the Python rider API identifies the row. */
  old_id: string;
  name: string;
  website_url: string;
  lat: number | null;
  lng: number | null;
  primary_color: string;
  secondary_color: string;
  organization_id: string;
  state: MerchantStoreState | null;
  /** Human-readable state for the table and detail pills. */
  status: string;
  logo_url: string | null;
  banner_url: string | null;
}

const STATE_LABELS: Record<string, string> = {
  LIVE: 'Live',
  RETIRED: 'Retired',
  INACTIVE: 'Inactive',
  UNKNOWN: 'Unknown',
};

export function merchantStoreStateLabel(state?: MerchantStoreState | null): string {
  if (!state) return 'Unknown';
  return STATE_LABELS[state] ?? 'Unknown';
}

export function mapMerchantStore(store: MerchantStoreGraphQL): IMerchantStore {
  return {
    id: store.id,
    old_id: store.oldId ?? '',
    name: store.name,
    website_url: store.websiteUrl ?? '',
    lat: store.lat ?? null,
    lng: store.lng ?? null,
    primary_color: store.primaryColor ?? '',
    secondary_color: store.secondaryColor ?? '',
    organization_id: store.organizationId,
    state: store.state ?? null,
    status: merchantStoreStateLabel(store.state),
    logo_url: store.logo?.url ?? null,
    banner_url: store.banner?.url ?? null,
  };
}

export function mapMerchantStores(stores: MerchantStoreGraphQL[]): IMerchantStore[] {
  return stores.map(mapMerchantStore);
}
